// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import LogoImage from '../../assets/images/login-logo.svg'
import ErrorImg from '../../assets/images/pic_error_internet.svg';
import LoginLayout from '../../layouts/LoginLayout';
import { Link } from 'react-router-dom';
import { getQueryParams, useQuery } from '../../lib/utility';
import ConfirmEmailPageLogo from './assets/confirm-email-page-logo.png'
import LoadingIcon from '../../components/LoadingIcon';
import { FormattedMessage, useIntl } from 'react-intl';
import S from './styles';

const ConfirmEmailPage = (): JSX.Element => {
  const { username, code, email } = getQueryParams(useQuery());
  const [isSuccess, setIsSuccess] = useState<boolean>();
  const history = useHistory();
  const intl = useIntl();
  useEffect(() => {
    let redirect: string;

    Auth.confirmSignUp(username, code)
      .then(data => {
        console.log({ data })
        setIsSuccess(true);
        redirect = '/login';
      })
      .catch((error) => {
        console.log({ error });
        setIsSuccess(false);
        redirect = '/register';
      })
      .finally(() => {
        console.log({ redirect });
        // if (redirect) {
        //   setTimeout(() => {
        //     history.push(redirect);
        //   }, 10000);
        // }
      });
  }, [username, code, setIsSuccess, history]);
  if (isSuccess) {
    return (
      <S.Layout>
        <S.Header src={LogoImage} />
        <S.Body>
          <S.Container alignX="center" alignY="center">
            <S.LeftWrapper>
              <S.Title>{intl.formatMessage({ id: 'J037' })}</S.Title>
              <S.DescriptionWrapper>
                <S.EmailLabel>{intl.formatMessage({ id: 'J038' })}</S.EmailLabel>
                <S.Email>{email}</S.Email>
                <S.Description>
                  {intl.formatMessage({ id: 'J038-2' })}
                </S.Description>
                <S.Description>
                  {intl.formatMessage({ id: 'J038-3' })}
                </S.Description>
              </S.DescriptionWrapper>
              <S.Button as={Link} to={'/login'}>{intl.formatMessage({ id: 'J039' })}</S.Button>
            </S.LeftWrapper>
            <S.Img src={ConfirmEmailPageLogo} alt="" />
          </S.Container>
        </S.Body>
      </S.Layout>
    );
  }
  if (isSuccess === false) {
    return (
      <LoginLayout>
        <S.FailedWrapper>
          <S.FailedImg src={ErrorImg} alt="" />
          <S.DescriptionWrapper>
            <S.FailedTitle>{intl.formatMessage({ id: 'J029' })}</S.FailedTitle>
            <S.FailedDescription>
              {intl.formatMessage({ id: 'J030' })}
            </S.FailedDescription>
          </S.DescriptionWrapper>
          <S.RegisterButton as={Link} to={'/register'}>{intl.formatMessage({ id: 'J031' })}</S.RegisterButton>
        </S.FailedWrapper>
      </LoginLayout>
    );
  }
  return (
    <S.Layout>
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    </S.Layout>
  );
}

export { ConfirmEmailPage as default }
